import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NavigationBarComponent } from './core/components/navigation-bar/navigation-bar.component';
import { FooterComponent } from './core/components/footer/footer.component';

@Component({
  selector: 'syn-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [NavigationBarComponent, RouterOutlet, FooterComponent],
})
export class AppComponent {
  protected readonly router = inject(Router);
  title = 'Synapse - Manager';
}
